import get from 'lodash/get.js';

export function getApiErrorMessage(error, fallback = 'Something went wrong. Please try again.') {
    return get(error, 'response.data.message') || get(error, 'response.data.error.message') || fallback;
}
